import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import Login from '../auth/authReducer';
import inputReducer from '../input/inputReducer';
import insightReducer from '../insight/insightReducer';
import distributionReducer from '../distribution/distributionReducer';
import libraryReducer from '../library/libraryReducer';
import exploreReducer from '../explore/exploreReducer';
import notificationReducer from '../notifications/notificationReducer';

const migrations: any = {
  1: (state: any) => ({ ...state }),
};

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  // Only persist mid-flow state so page refresh doesn't lose in-progress work
  whitelist: ['Insight', 'Distribution'],
  migrate: createMigrate(migrations, { debug: false }),
};

const rootReducer = combineReducers({
  Auth:          Login,
  Input:         inputReducer,
  Insight:       insightReducer,
  Distribution:  distributionReducer,
  Library:       libraryReducer,
  Explore:       exploreReducer,
  Notifications: notificationReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
